<template>
  <div class="join join--between join--mobile-col join--tablet-col">
    <form-info :form="form" :readonly="readonly" />
    <form-calendar :form="form" />
  </div>
</template>

<script setup>
import FormInfo from '../form/_FormInfo.vue'
import FormCalendar from '../form/_FormCalendar.vue'

defineProps({
  form: { type: Object,  default: () => ({}) },
  readonly: { type: Boolean, default: false },
})
</script>
